var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "price-table",
        { "price-table--only-once-product": !!_vm.onlyProductId }
      ]
    },
    [
      _vm.loading
        ? _c("Loading")
        : [
            _c(
              "div",
              { staticClass: "d-lg-none" },
              [
                _vm._l(_vm.productsMobile, function(product) {
                  return _c(
                    "div",
                    {
                      key: product ? product.id : "free",
                      staticClass: "price-table--item"
                    },
                    [
                      _c("div", { staticClass: "price-table--header" }, [
                        _c(
                          "div",
                          {
                            class: [
                              "price-table--header-item",
                              _vm.getProductsHeaderBackgroundClass(product)
                            ]
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(product ? product.label : "Test") +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "price-table--feature-content" },
                        [
                          _c(
                            "div",
                            { staticClass: "price-table--feature" },
                            [
                              _c("Icon", {
                                attrs: {
                                  icon: "checkmark",
                                  color: _vm.getProductColor(product)
                                }
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t\tUnlimitierte Jobs\n\t\t\t\t\t"
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "price-table--feature" },
                            [
                              _c("Icon", {
                                attrs: {
                                  icon: "checkmark",
                                  color: _vm.getProductColor(product)
                                }
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t\tUnlimitierte Filter\n\t\t\t\t\t"
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "price-table--feature" },
                            [
                              _c("Icon", {
                                attrs: {
                                  icon: "checkmark",
                                  color: _vm.getProductColor(product)
                                }
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t\tBest-Match-System\n\t\t\t\t\t"
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "price-table--feature" },
                            [
                              _c("Icon", {
                                attrs: {
                                  icon: "checkmark",
                                  color: _vm.getProductColor(product)
                                }
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t\tBewerbermanagement\n\t\t\t\t\t"
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "price-table--feature" },
                            [
                              _c("Icon", {
                                attrs: {
                                  icon: "checkmark",
                                  color: _vm.getProductColor(product)
                                }
                              }),
                              _vm._v("\n\t\t\t\t\t\tKontaktsystem\n\t\t\t\t\t")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-3" }, [
                            _c(
                              "span",
                              {
                                class: [
                                  "font-size-big4",
                                  "font-weight-bold",
                                  "color-" + _vm.getProductColor(product)
                                ]
                              },
                              [
                                product
                                  ? [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            product.contactingsPerMonth
                                              ? product.contactingsPerMonth
                                              : "Unlimitiert"
                                          ) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  : [_vm._v("0")]
                              ],
                              2
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t\tKontaktierungen pro Monat\n\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          !product
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "price-table--feature-content-price"
                                },
                                [_c("Free")],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "price-table--feature-content-price"
                                },
                                [
                                  product && _vm.withPrices
                                    ? _c("BuyButton", {
                                        attrs: {
                                          product: product,
                                          "upgradable-items":
                                            _vm.upgradableItems,
                                          "chosen-product": _vm.chosenProduct,
                                          "custom-button-click-handler":
                                            _vm.customButtonClickHandler
                                        },
                                        on: {
                                          buy: function($event) {
                                            return _vm.$emit("buy", $event)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.withPrices
                  ? _c("div", { staticClass: "mt-4 font-size-smaller" }, [
                      _vm._v("Alle Preise in EURO exkl. USt.")
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-none d-lg-block" },
              [
                _c(
                  "div",
                  { staticClass: "price-table--header" },
                  [
                    _c("div", [_vm._v(" ")]),
                    _vm._v(" "),
                    _vm.withFree
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "price-table--header-item bg-color-purple"
                          },
                          [_vm._v("Test")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.products, function(product) {
                      return _c(
                        "div",
                        {
                          key: product.id,
                          class: [
                            "price-table--header-item",
                            _vm.getProductsHeaderBackgroundClass(product)
                          ]
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(product.label) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("Feature", {
                  attrs: {
                    "with-free": _vm.withFree,
                    text: "Unlimitierte Jobs:",
                    products: _vm.products,
                    "free-checked": ""
                  }
                }),
                _vm._v(" "),
                _c("Feature", {
                  attrs: {
                    "with-free": _vm.withFree,
                    text: "Unlimitierte Filter:",
                    products: _vm.products,
                    "free-checked": ""
                  }
                }),
                _vm._v(" "),
                _c("Feature", {
                  attrs: {
                    "with-free": _vm.withFree,
                    text: "Best-Match-System:",
                    products: _vm.products,
                    "free-checked": ""
                  }
                }),
                _vm._v(" "),
                _c("Feature", {
                  attrs: {
                    "with-free": _vm.withFree,
                    text: "Bewerbermanagement:",
                    products: _vm.products,
                    "free-checked": ""
                  }
                }),
                _vm._v(" "),
                _c("Feature", {
                  attrs: {
                    "with-free": _vm.withFree,
                    text: "Kontaktsystem:",
                    products: _vm.products,
                    "free-checked": ""
                  }
                }),
                _vm._v(" "),
                _c("Feature", {
                  attrs: {
                    "with-free": _vm.withFree,
                    text: "Anzahl Kontaktierungen:",
                    "sub-text": "pro Monat",
                    products: _vm.products,
                    type: "content",
                    "content-provider": function(product) {
                      return product.contactingsPerMonth || "unlimitiert"
                    }
                  }
                }),
                _vm._v(" "),
                _vm.withPrices
                  ? _c("Feature", {
                      attrs: {
                        "with-free": _vm.withFree,
                        text: "Alle Preise in EURO exklusive USt.",
                        products: _vm.products,
                        type: "price",
                        "custom-button-click-handler":
                          _vm.customButtonClickHandler,
                        "chosen-product": _vm.chosenProduct,
                        "upgradable-items": _vm.upgradableItems
                      },
                      on: {
                        buy: function($event) {
                          return _vm.$emit("buy", $event)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }